export default __webpack_public_path__ + "static/media/children.8392b192.svg";